import { ONE_SECOND } from 'services/api/ApiClientService/constants';

// Calculates the delay (in milliseconds) between retry attempts.
export const countRetryDelay = (retryCount: number): number => retryCount * ONE_SECOND;
